import * as React from 'react';
import { FC, Fragment, useEffect } from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    DateInput,
    downloadCSV,
    EmailField,
    Filter,
    List,
    SearchInput,
    SelectInput,
    TextField,
    NumberInput,
    usePermissions,
    useTranslate,
    TextInput,
    ReferenceInput,
    ReferenceField
} from 'react-admin';

import ListActions from '../components/actions';
import BulkDeleteButton from './actionsBulkDelete';
import BulkRecoverButton from './actionsBulkRecover';

import ListEmpty from '../components/listEmpty';
import { FilterProps, PermissionsType } from "../../types";
import ListPagination from "../components/ListPagination";
import CustomizableDatagrid from '../components/CustomizableDatagrid';
import Fields from './dataset';
import { STATUS } from './dataset'
import { NumberField } from 'react-admin';
import { ImageField } from 'react-admin';
import { SelectField } from 'react-admin';
import ChipFieldJsonb from '../components/ChipFieldJsonb';
import { AutocompleteInput } from 'react-admin';
import StatusField from './StatusField';
import exporter from './exporter';
import { useHistory } from 'react-router';

const ExportableFields = Fields.filter(d => d.export);

const UserBulkActionButtons = (props: JSX.IntrinsicAttributes) => {
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    const { filterValues: { status } } = props as any
    return (
        <Fragment>
           {(role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkRecoverButton {...props} />}
            {(role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkDeleteButton {...props} />}
        </Fragment>
    )
};
const TeamFilter: FC<Omit<FilterProps, 'children'>> = props => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <NumberInput source="id@_eq" label={translate('user_list.id')} alwaysOn />
            <ReferenceInput
                filterToQuery={(searchText: ' ') => ({ 'firstname': searchText })}
                source="user_id" reference="user" alwaysOn label={translate('user_point.user')}>
                <AutocompleteInput optionText="firstname" />
            </ReferenceInput>
            <SelectInput choices={STATUS} source="status" label={translate('team_review.status')} alwaysOn />
            <SearchInput source="title,nickname,review,note" alwaysOn />
        </Filter>
    )
};

const UserList = (props: any) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    let edit = (permission?.permission_create_edit == true || permission?.permission_all == true) ? 'edit': '';
    const module = 'team_review';
    const history = useHistory();
    useEffect( () => {
        history.location.pathname = '/team_review_trash';
    },[props]);
    if (role ===undefined) {
        return null;
    }
    console.log({ permissions });

    return (
        <List
            {...props}
            filters={<TeamFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            filterDefaultValues={{ status: 0, is_soft_deleted: true }}
            perPage={25}
            bulkActionButtons={<UserBulkActionButtons />}
            pagination={<ListPagination />}
            exporter={(items: any, fetchRelatedRecords: any) => exporter(items, 'team_review', ExportableFields, translate, fetchRelatedRecords)}
            actions={<ListActions to='team_review' />}
            empty={<ListEmpty />}
            title={translate('menu.team_review.list')}
        >
            <CustomizableDatagrid>

                {Fields.map((f, idx) => {
                    if (!Boolean(f)) return <></>
                    const { name, reference, searchField, type, options, numberFormat } = f || {}
                    if (type === 'textinput' && name !== 'created') {
                        if (numberFormat) {
                            return <NumberField source={name} label={translate(`${module}.${name}`)} />
                        }
                        return <TextField source={name} label={translate(`${module}.${name}`)} />
                    }
                    if (type === 'status' && (name === 'score_1' || name === 'score_2' || name === 'score_3' || name === 'score_4' || name === 'score_5' || name === 'score_6')) {
                        return <NumberField source={name} label={translate(`${module}.${name}`)} />
                    }
                    if (type === 'status') {
                        return <StatusField source={name} label={translate(`${module}.${name}`)} />
                    }

                    if (type === 'reference') {
                        if (searchField === 'lastname') {
                            return <ReferenceField label={translate(`${module}.${searchField}`)} source={name} reference={reference}>
                                <TextField source={searchField} />
                            </ReferenceField>
                        }
                        if (searchField === 'firstname') {
                            return <ReferenceField label={translate(`${module}.${searchField}`)} source={name} reference={reference}>
                                <TextField source={searchField} />
                            </ReferenceField>
                        }
                        if (searchField === 'nickname') {
                            return <ReferenceField label={translate(`${module}.${searchField}`)} source={name} reference={reference}>
                                <TextField source={searchField} />
                            </ReferenceField>
                        } else {
                            return <ReferenceField label={translate(`${module}.${name}`)} source={name} reference={reference}>
                                <TextField source={searchField} />
                            </ReferenceField>
                        }

                    }

                    if (type === 'date' || type === 'datetime' || name === 'created') {
                        return <DateField showTime={true} source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />
                    }
                    if (type === 'imagefield') {
                        return <ImageField source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />
                    }

                    if (type === 'checkbox') {
                        return <BooleanField source={name} label={translate(`${module}.${name}`)} />
                    }

                    if (type === 'selectbox') {
                        return <SelectField
                            source={name}
                            choices={options}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'jsonb') {
                        return <ChipFieldJsonb
                            source={name}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    return <></>
                })}
            </CustomizableDatagrid>
        </List>

    );
};

export default UserList;
